module.exports = __webpack_public_path__ + "static/media/syncWhatsapp_step1_ch.d32b5354.jpg";